module.exports = __webpack_public_path__ + "img/2_2_3__2.cc729f8b.png";